module.exports = {
  element: "div",
  className: "leftPanel",
  gid: "spritesLeftPanel",
  children: [
    {
      element: "div",
      className: "tabArea",
      gid: "tabArea",
    },
    {
      element: "div",
      className: "tabWindow",
      gid: "tabWindow",
      children: [
        {
          element: "div",
          className: "blocklyDiv",
          gid: "blocklyDiv",
        },
        {
          element: "div",
          className: "costumesContainer",
          gid: "costumesContainer",
          children: [
            {
              element: "div",
              className: "costumesHeaderContainer",
              gid: "costumesHeaderContainer",
            },
            {
              element: "div",
              className: "costumesSelectorContainer",
              gid: "costumesSelectorContainer",
            },
          ],
        },
        {
          element: "div",
          className: "soundsContainer",
          gid: "soundsContainer",
          children: [
            {
              element: "div",
              className: "soundsHeaderContainer",
              gid: "soundsHeaderContainer",
            },
            {
              element: "div",
              className: "soundsSelectorContainer",
              gid: "soundsSelectorContainer",
            },
          ],
        },
        require("./costumepivot.js"),
        {
          element: "div",
          className: "errorLogsContainer",
          gid: "errorLogsContainer",
        },
      ],
    },
  ],
};
